var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackrsIcon } from '@backrs_ui/common-ui/src/atoms/BackrsIcon';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import { DRAWER_WIDTH_EXPANDED } from './constants';
export var SidebarLogo = function (_a) {
    var label = _a.label, iconMeta = _a.iconMeta, isOpen = _a.isOpen, labelAsComponent = _a.labelAsComponent;
    var disabled = typeof (iconMeta === null || iconMeta === void 0 ? void 0 : iconMeta.onClick) === 'function';
    var isSmallScreenHeight = useMediaQuery('(max-height: 600px)');
    return (_jsx(IconButton, { disabled: !disabled, sx: iconButtonStyle, onClick: function () { var _a; return (_a = iconMeta.onClick) === null || _a === void 0 ? void 0 : _a.call(iconMeta); }, children: _jsxs(Box, { sx: iconAndLabelStyle, children: [_jsx(BackrsIcon, { name: iconMeta.icon, alt: iconMeta.alt, style: logoStyle({ isOpen: isOpen, extraStyle: iconMeta.style, isSmallScreenHeight: isSmallScreenHeight }) }), labelAsComponent || _jsx(Typography, { sx: lubavTextStyle(isOpen), children: label })] }) }));
};
var lubavTextStyle = function (isOpen) { return ({
    fontSize: '24pt',
    color: '#03295F',
    paddingLeft: '8px',
    opacity: isOpen ? 1 : 0,
    transition: 'opacity 0.3s ease',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'block',
}); };
var iconAndLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    minHeight: '44px',
    width: '100%',
};
var logoStyle = function (_a) {
    var isOpen = _a.isOpen, extraStyle = _a.extraStyle, isSmallScreenHeight = _a.isSmallScreenHeight;
    var smallScreenIconWidth = isOpen ? '40px' : '32px';
    var largerScreenIconWidth = isOpen ? '60px' : '32px';
    var width = isSmallScreenHeight ? smallScreenIconWidth : largerScreenIconWidth;
    return __assign({ width: width, height: isSmallScreenHeight ? 'unset' : 'auto', transition: 'width 0.4s' }, extraStyle);
};
var iconButtonStyle = {
    borderRadius: '16px',
    padding: '0px 4px',
    '@media (max-height: 600px)': {
        maxHeight: '40px',
    },
    width: "calc(".concat(DRAWER_WIDTH_EXPANDED, "px - 20px)"),
    transition: 'background-color 0.3s, border-radius 0.3s',
    '&:hover': { backgroundColor: 'transparent' },
    marginBottom: '12px',
    height: '70px',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
};
